import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandM, BrandXXS } from '@sorare/core/src/atoms/typography';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import bg from './assets/bg.webp';

export const StreaksPromotionWrapper = styled(Horizontal).attrs({ gap: 2 })`
  overflow: hidden;
  position: relative;

  text-align: left;
  padding: var(--unit) var(--double-unit);
  border: 1px solid transparent;
  margin: 0 -1px;
  ${BrandXXS} {
    --typography-font: var(--t-brand-xxs);
  }
  ${BrandM} {
    --typography-font: var(--t-brand-s);
  }

  @media (${tabletAndAbove}) {
    border-radius: var(--double-unit);
    padding: var(--double-unit);
    margin: 0;
    gap: var(--quadruple-unit);
    ${BrandXXS} {
      --typography-font: var(--t-brand-xs);
    }
    ${BrandM} {
      --typography-font: var(--t-brand-m);
    }
  }
  background:
    linear-gradient(to right, var(--c-nl-800), var(--c-nl-400)) padding-box,
    no-repeat center / cover url(${bg}) padding-box,
    linear-gradient(160deg, #ff4e22, #fef314) border-box;
  box-shadow:
    0px 0px 4px 0px rgba(254, 193, 24, 0.25) inset,
    0px 0px 8px 0px rgba(255, 78, 34, 0.5);
`;
